import React from "react";
import "../css/others/Popup.css";
import { FormulaPopupProps } from '../interFaces/interfaces';
const FormulaPopup: React.FC<FormulaPopupProps> = ({ formula, onClose }) => {
  return (
    <div className="buildformula-overlay">
      <div className="buildformula-content">
        <div className="buildformula-header">
          <h3>Build Formula</h3>
          <button className="buildformula-close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="buildformula-body">
          <div className="display-screen1">{formula}</div>
        </div>
        <div className="buildformula-footer">
          <button className="buildformula-button" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};
export default FormulaPopup;